var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 68,
    viewBox: "0 0 75 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 68,
    height: 68,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1920_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4263 42.2335H18.7495L19.9618 41.7521C20.5434 41.5212 21.1286 41.7726 21.4263 42.2335Z",
    fill: "#D3AA29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.273 52.4679C24.1141 53.257 23.4006 53.8956 22.5016 53.7909L18.1626 53.2928C17.6322 53.2318 17.106 53.4434 16.7562 53.858L13.903 57.2421C13.022 58.2867 11.3563 57.8396 11.0841 56.4861L10.1976 52.0984C10.0899 51.5612 9.73048 51.112 9.23786 50.8993L5.21518 49.1546C3.97424 48.6158 3.87104 46.8527 5.04063 46.1695L8.83198 43.9563C9.29581 43.6857 9.5997 43.1971 9.64516 42.651L10.0119 38.1875C10.1258 36.8115 11.7276 36.1688 12.724 37.0999L15.3215 39.5294L15.9523 40.1191C16.348 40.4898 16.8947 40.6356 17.4151 40.5117L19.5055 40.0137C19.3443 41.1044 19.0878 42.1626 19.0956 43.2181C19.1119 45.1895 20.1929 46.7743 21.8975 47.5864L24.0688 51.2752C24.2967 51.6628 24.3511 52.0837 24.273 52.4679Z",
    fill: "#D3AA29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3345,
    y: 40.7114,
    width: 33.3349,
    height: 8.84688,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4282,
    y: 18.1221,
    width: 48.4786,
    height: 31.4215,
    rx: 3,
    stroke: "#005AA0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3345,
    y: 36.7817,
    width: 46.6688,
    height: 5.89792,
    fill: "#005AA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6675 24.0203C19.6675 23.468 20.1152 23.0203 20.6675 23.0203H25.3345C25.8867 23.0203 26.3345 23.468 26.3345 24.0203V26.9352C26.3345 27.4875 25.8867 27.9352 25.3345 27.9352H20.6675C20.1152 27.9352 19.6675 27.4875 19.6675 26.9352V24.0203Z",
    fill: "#005AA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8388 10.2179L63.8348 14.3678C64.0789 14.8764 64.5517 15.2286 65.0984 15.3098L69.5616 15.9755C70.9383 16.1805 71.488 17.9165 70.4915 18.9124L67.2615 22.1431C66.8657 22.5386 66.6852 23.1086 66.7792 23.6673L67.5419 28.2286C67.7772 29.6352 66.3383 30.7078 65.1072 30.0436L61.1153 27.8901C60.6263 27.6267 60.0426 27.6267 59.5536 27.8901L55.5616 30.0436C54.3306 30.7078 52.8917 29.6352 53.127 28.2286L53.8897 23.6673C53.9829 23.1086 53.8024 22.5386 53.4073 22.1431L50.1774 18.9124C49.1816 17.9165 49.7313 16.1805 51.1073 15.9755L55.5705 15.3098C56.1172 15.2286 56.59 14.8764 56.8341 14.3678L58.8301 10.2179C59.4456 8.9381 61.2233 8.9381 61.8388 10.2179Z",
    fill: "#D3AA29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1920_2750",
    x: 0.221191,
    y: 7.25806,
    width: 74.7793,
    height: 56.5608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1920_2750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1920_2750",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.d64e089ea87e88b998898a321aff1d18.svg";
export { ForwardRef as ReactComponent };